/**
 * Проверка, не устарел ли работающий бандл.
 *
 * Больной сценарий: вкладка стенда живёт открытой днями, страница — SPA и сама
 * не перезагружается. Код в ней остаётся недельной давности, а данные (шаблоны,
 * аккаунты) рефетчатся свежими — и сотрудник публикует пост, отрисованный
 * старым кодом: одноцветные заголовки, старые размеры (отзыв редакции 04.09).
 * Самолечение после выкатки ловит только упавшие ленивые чанки; полностью
 * закэшированный старый бандл для него невидим.
 *
 * Поэтому перед публикацией сверяем entry-бандл: какой подключён у страницы
 * и какой сервер отдаёт прямо сейчас. Разошлись — публиковать из этой вкладки
 * нельзя, нужна перезагрузка. Любая ошибка самой проверки трактуется в пользу
 * публикации: страж не должен стать причиной сорванного выпуска.
 */

export function extractEntryBundle(html: string): string | null {
  const m = html.match(/assets\/index-[\w-]+\.js/);
  return m ? m[0] : null;
}

export function currentEntryBundle(doc: Document = document): string | null {
  const el = doc.querySelector('script[src*="assets/index-"]');
  const src = el?.getAttribute('src') ?? '';
  return extractEntryBundle(src);
}

/** true — сервер уже отдаёт другой бандл, вкладка устарела. */
export async function isBundleStale(): Promise<boolean> {
  try {
    const running = currentEntryBundle();
    if (!running) return false; // dev-сервер или незнакомая разметка — не мешаем
    const res = await fetch('/', { cache: 'no-store' });
    if (!res.ok) return false;
    const served = extractEntryBundle(await res.text());
    return served !== null && served !== running;
  } catch {
    return false;
  }
}

export const STALE_BUNDLE_MESSAGE =
  'Вышло обновление сайта — перезагрузите страницу (Cmd+Shift+R) и опубликуйте заново';
